import React, { useState } from 'react';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const Logo = ({
  logo,
  title,
  position,
  description,
  description2,
  description3,
  description4
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Card Section */}
      <div className="flex flex-col items-center text-center">
        {/* Logo Circle */}
        <div className="w-24 h-24 rounded-full bg-blue-300 flex items-center justify-center animate-shine">
          <h1 className="text-xl md:text-2xl lg:text-3xl font-bold text-black">
            {logo}
          </h1>
        </div>

        {/* Name & Position */}
        <div className="mt-4">
          <h2 className="font-bold text-black whitespace-nowrap text-base md:text-lg lg:text-xl">
            {title}
          </h2>
          <p className="text-black text-sm md:text-base lg:text-lg">
            {position}
          </p>
        </div>

        {/* Read More */}
        <div className="mt-4">
          <button
  className="inline-flex items-center justify-center px-8 py-4 bg-blue-900 hover:bg-blue-500 text-white text-lg font-semibold rounded-xl shadow-lg transition-all duration-300 hover:scale-105"
  onClick={() => setOpen(true)}
>
  Read More
</button>
        </div>
      </div>

      {/* Modal */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
  sx={{
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",

    width: "100%",
    maxWidth: "1280px",
    px: { xs: 2, sm: 4, lg: 8 },

    maxHeight: { xs: "90vh", md: "80vh" },
    overflowY: "auto",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: 2,
  }}
>
          {/* Left Section */}
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              borderBottom: { xs: '1px solid #ddd', md: 'none' },
              borderRight: { md: '1px solid #ddd' },
              pb: { xs: 2, md: 0 },
              pr: { md: 2 },
            }}
          >
            <Box
              sx={{
                width: 96,
                height: 96,
                borderRadius: '50%',
                background: '#93c5fd',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 2,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 'bold',
                  fontSize: { xs: '1.25rem', md: '1.5rem', lg: '1.75rem' },
                }}
              >
                {logo}
              </Typography>
            </Box>

            <Typography
              sx={{
                fontWeight: 'bold',
                fontSize: { xs: '1rem', md: '1.25rem', lg: '1.5rem' },
              }}
            >
              {title}
            </Typography>

            <Typography
              sx={{
                color: 'text.secondary',
                fontSize: { xs: '0.875rem', md: '1rem', lg: '1.125rem' },
              }}
            >
              {position}
            </Typography>
          </Box>

          {/* Right Section */}
          <Box sx={{ flex: 2, pl: { md: 2 }, pt: { xs: 2, md: 0 } }}>
            {[description, description2, description3, description4]
              .filter(Boolean)
              .map((text, index) => (
                <Typography
                  key={index}
                  sx={{
                    textAlign: 'justify',
                    fontSize: { xs: '0.95rem', md: '1.125rem', lg: '1.25rem' },
                    lineHeight: 1.8,
                    mb: 2,
                  }}
                >
                  {text}
                </Typography>
              ))}
          </Box>

          {/* Close Button */}
          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              color: 'text.secondary',
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Modal>
    </>
  );
};

export default Logo;
